exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-box[data-v-97c737e8] {\n  font-size: 16px;\n  font-weight: 500;\n  position: relative;\n}\n.title-box[data-v-97c737e8]::before {\n  content: \" \";\n  background-color: #409eff;\n  width: 4px;\n  height: 100%;\n  border-radius: 1px;\n  position: absolute;\n  left: -10px;\n}", ""]);

// exports
